import { AriaAttributes, ReactNode } from 'react';

export enum CardVariant {
	Container = 'container',
	Inverse = 'inverse',
}

export interface CardProps extends AriaAttributes{
	className?: string;
	children: ReactNode;
	variant?: CardVariant;
}
